module.exports = __webpack_public_path__ + "img/1.d88e07e8.jpg";